function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "eq25gntmba"
}, /*#__PURE__*/React.createElement("path", {
  transform: "translate(1.329)",
  d: "M0 0h24v24H0z"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.969 21.5a7.442 7.442 0 0 0-4.662 1.635 2.619 2.619 0 0 1 .128.734 2.329 2.329 0 0 1-2.327 2.331h-.074a7.47 7.47 0 1 0 6.935-4.7zm-4.848 5.376A4.277 4.277 0 0 1 25.7 26.6a3.886 3.886 0 0 1 1.564.3l-.328.747a3.836 3.836 0 0 0-1.235-.176 4.447 4.447 0 0 0-1.263.152zm4.848 6.863a3.555 3.555 0 0 1-3.407-2.939h6.814a3.555 3.555 0 0 1-3.407 2.939zm4.521-6.085a3.836 3.836 0 0 0-1.235-.176 4.447 4.447 0 0 0-1.263.152l-.317-.752a4.277 4.277 0 0 1 1.581-.272 3.886 3.886 0 0 1 1.564.3z",
  transform: "translate(-15.11 -16.381)"
});

function SvgSmilingFaceWithTear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.329)",
    style: {
      clipPath: "url(#eq25gntmba)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.449 20.548a1.672 1.672 0 1 0 3.344 0c0-1.064-1.672-3.548-1.672-3.548s-1.672 2.485-1.672 3.548z",
    style: {
      fillRule: "evenodd"
    },
    transform: "translate(-12.121 -13.06)"
  }), _ref3));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmilingFaceWithTear);
export default __webpack_public_path__ + "static/media/smiling-face-with-tear.09dfa4a3.svg";
export { ForwardRef as ReactComponent };